import type { GetApprovalAuditByIdResponseRow } from '@risksmart-app/drizzle/src/types';
import { GetApprovalAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

import type { AuditLogQueryResult } from './auditLogQueryResult';

type UseGetApprovalAuditByIdArgs = {
  id: string;
};

export const useGetApprovalAuditById = createQueryHook<
  UseGetApprovalAuditByIdArgs,
  GetApprovalAuditByIdResponseRow[],
  AuditLogQueryResult<'approval_audit', GetApprovalAuditByIdResponseRow>
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getApprovalAuditById.queryOptions({
      id,
    }),
  mapTrpcDataToGraphQL: (data) => ({ approval_audit: data }),
  graphqlDocument: GetApprovalAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
